// Copyright (c) 2026 CTO's Club LLC. All rights reserved.
// Author: Alex Baretta (alex@baretta.com).

import { ALL_RPA_MODULE_NAMES, RpaModuleName } from './backend_config.types';
import { IpgSystemId, IpwSystemId } from './types/third-party-system.enums';

export type RpaModuleAuthorizationTarget =
    | { readonly kind: 'ipw'; readonly systemId: IpwSystemId }
    | { readonly kind: 'ipg'; readonly systemId: IpgSystemId };

export const RpaModuleAuthorizationTargetByModuleName: Readonly<
    Record<RpaModuleName, RpaModuleAuthorizationTarget>
> = {
    [RpaModuleName.PCPARTPICKER_IPW]: {
        kind: 'ipw',
        systemId: IpwSystemId.PCPARTPICKER,
    },
    [RpaModuleName.DEALERTRACK_IPW]: {
        kind: 'ipw',
        systemId: IpwSystemId.DEALERTRACK,
    },
    [RpaModuleName.PCPARTPICKER_WORKFLOWS]: {
        kind: 'ipw',
        systemId: IpwSystemId.PCPARTPICKER,
    },
    [RpaModuleName.STONEPROFITS_WORKFLOWS]: {
        kind: 'ipw',
        systemId: IpwSystemId.GENERIC,
    },
    [RpaModuleName.GENERIC_WEBSITE_WORKFLOWS]: {
        kind: 'ipw',
        systemId: IpwSystemId.GENERIC,
    },
    [RpaModuleName.VALORPAYTECH_IPG]: {
        kind: 'ipg',
        systemId: IpgSystemId.VALOR_US,
    },
    [RpaModuleName.VALORPAYTECH_WORKFLOWS]: {
        kind: 'ipg',
        systemId: IpgSystemId.VALOR_US,
    },
    [RpaModuleName.CARDPOINTE_IPG]: {
        kind: 'ipg',
        systemId: IpgSystemId.CARDPOINTE,
    },
    [RpaModuleName.CLOVER_IPG]: {
        kind: 'ipg',
        systemId: IpgSystemId.CLOVER,
    },
};

export function getRpaModuleAuthorizationTarget(
    moduleName: RpaModuleName
): RpaModuleAuthorizationTarget {
    return RpaModuleAuthorizationTargetByModuleName[moduleName];
}

export function assertCompleteRpaModuleAuthorizationTargets(): void {
    const mappedModuleNames = Object.keys(RpaModuleAuthorizationTargetByModuleName);
    if (
        mappedModuleNames.length !== ALL_RPA_MODULE_NAMES.length ||
        ALL_RPA_MODULE_NAMES.some((moduleName) => !mappedModuleNames.includes(moduleName))
    ) {
        throw new Error('Every RPA module must have exactly one authorization target');
    }
}
